module.exports = __webpack_public_path__ + "static/media/Icon_10.ec6065b6.svg";